//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (code, successCallback, failureCallback) => {
        ApiService.post("/web/admin/language/edit/loadscreenview", { code }, successCallback, failureCallback);
    },
    saveLanguage: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/language/edit/save", vo, successCallback, failureCallback);
    },
    uploadLogo: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Languages");
        formData.append("field", "Logo");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    }
};

export default EditService;